// extracted by mini-css-extract-plugin
export default {"FreeText":"styles_FreeText__RpUHw"};